<template>
  <div class="works-list" ondragstart="return false" oncontextmenu="return false">
    <ei-header :header-show="false" :header2-show="true" :header2-lit="header2Lit"></ei-header>
    <ei-long-figure-scroll-for-person :works-list="typeof worksList==='undefined'?[]:worksList" style="margin-top: 74px"></ei-long-figure-scroll-for-person>
    <ei-music style="margin-top: 17px;margin-left: 190px;position:fixed;"></ei-music>
    <DropdownPluginWriter  style="margin-left: 128px;position: absolute;"
                           :personName="writerPersonLists"
                           :lieWidth="lieWidth" :lieHeight="lieHeight" :lieFontSzie="lieFontSzie" :lieMarginLeft="lieMarginLeft"
    ></DropdownPluginWriter>
    <DropdownPluginPainter style="margin-left: 1810px;position: absolute;"
                           :personName="painterPersonLists"
                           :lieWidth="lieWidth" :lieHeight="lieHeight" :lieFontSzie="lieFontSzie" :lieMarginLeft="lieMarginLeft"
    ></DropdownPluginPainter>

    <div v-if="this.type=='清鉴集'" style="margin-top: -20px">
      <div class="title-wrap">
        <img src="../eiuov-ui/_ei-flower/1.png" alt="">
        <span>《凌烟阁大法帖》·  {{type}}</span>
        <img src="../eiuov-ui/_ei-flower/1.png" alt="">
      </div>
      <ei-works-page :works-page="writerWorksPage" @pageNumChange="writerPageNumChange" ></ei-works-page>
      <div class="title-wrap" >
        <img src="../eiuov-ui/_ei-flower/1.png" alt="">
        <span>《凌烟阁大画谱》·  {{type}}</span>
        <img src="../eiuov-ui/_ei-flower/1.png" alt="">
      </div>
      <ei-works-page :works-page="painterWorksPage" @pageNumChange="writerPageNumChange" ></ei-works-page>
    </div>
    <div v-else style="margin-top: -20px">
      <div class="title-wrap" >
        <img src="../eiuov-ui/_ei-flower/1.png" alt="">
        <span v-if="this.type=='书法集'">《凌烟阁大法帖》· 书法集</span>
        <span v-if="this.type=='绘画集'">《凌烟阁大画谱》·  绘画集</span>
        <img src="../eiuov-ui/_ei-flower/1.png" alt="">
      </div>
      <ei-works-page :works-page="worksPage" @pageNumChange="pageNumChange" ></ei-works-page>
    </div>

    <ei-footer></ei-footer>
  </div>
</template>

<script>
import {queryPersonByCoverArea, queryWorksListAction, queryWorksPageAction} from '@/api/reception/works-api'
import { isFailure } from '@/eiuov-utils/axios/response'

export default {
  name: 'WorksList',
  data () {
    return {
      lieWidth:31,
      lieHeight:28,
      lieMarginLeft:-50,
      lieFontSzie:23,
      type: '',
      titleButterflyImg: '/upload/homeBlock/1/titleButterflyImg.png',
      worksList:[],
      allPersonList:[],
      writerPersonLists: [],
      painterPersonLists: [],
      writerLists:[],
      painterLists:[],
      worksPage: {
        list: [],
        total: 0,
        pageSize: 8,
        pageNum: 1,
      },
      writerWorksPage: {
        list: [],
        total: 0,
        pageSize: 8,
        pageNum: 1,
      },
      painterWorksPage:{
        list: [],
        total: 0,
        pageSize: 8,
        pageNum: 1,
      },
      header2Lit: false,
    }
  },
  created () {
    this.initHeader()
    this.type = this.$route.query.type
    queryWorksPageAction({
      type: this.type,
      pageNum: this.worksPage.pageNum,
      pageSize: this.worksPage.pageSize
    }).then((res) => {
      if (isFailure(res)) return
      this.worksPage.list = res.data.list
      this.worksPage.total = res.data.total
      this.worksPage.wordCountTotal = res.data.wordCountTotal
    })
    queryWorksListAction({
      type: this.type,
    }).then((res) => {
      if (isFailure(res)) return
      this.worksList = res.data.list
    })
    queryPersonByCoverArea({}).then((res) => {
      if (isFailure(res)) return
      this.writerPersonLists = res.data.writerPersonLists
      this.painterPersonLists = res.data.painterPersonLists
    })

    queryWorksPageAction({
      type:'书法集',
      pageNum: this.writerWorksPage.pageNum,
      pageSize: this.writerWorksPage.pageSize
    }).then((res) => {
      if (isFailure(res)) return
      this.writerWorksPage.list = res.data.list
      this.writerWorksPage.total = res.data.total
      this.writerWorksPage.wordCountTotal = res.data.wordCountTotal
    })
    queryWorksPageAction({
      type:'绘画集',
      pageNum: this.painterWorksPage.pageNum,
      pageSize: this.painterWorksPage.pageSize
    }).then((res) => {
      if (isFailure(res)) return
      this.painterWorksPage.list = res.data.list
      this.painterWorksPage.total = res.data.total
      this.painterWorksPage.wordCountTotal = res.data.wordCountTotal
    })
  },
  methods: {
    toWorkDetail (rowGuid) {
      this.$router.push({
        path: '/WorksDetail',
        query: { guid: rowGuid },
      })
    },
    pageNumChange (pageNumNew) {
      this.worksPage.pageNum = pageNumNew
      queryWorksPageAction({
        type: this.type,
        pageNum: this.worksPage.pageNum,
        pageSize: this.worksPage.pageSize
      }).then((res) => {
        if (isFailure(res)) return
        this.worksPage.list = res.data.list
        this.worksPage.total = res.data.total
        this.worksPage.wordCountTotal = res.data.wordCountTotal
      })
    },
    writerPageNumChange (pageNumNew) {
      this.writerWorksPage.pageNum = pageNumNew
      queryWorksPageAction({
        type: this.type,
        pageNum: this.writerWorksPage.pageNum,
        pageSize: this.writerWorksPage.pageSize
      }).then((res) => {
        if (isFailure(res)) return
        this.writerWorksPage.list = res.data.list
        this.writerWorksPage.total = res.data.total
        this.writerWorksPage.wordCountTotal = res.data.wordCountTotal
      })
    },
    painterPageNumChange (pageNumNew) {
      this.painterWorksPage.pageNum = pageNumNew
      queryWorksPageAction({
        type: this.type,
        pageNum: this.painterWorksPage.pageNum,
        pageSize: this.painterWorksPage.pageSize
      }).then((res) => {
        if (isFailure(res)) return
        this.painterWorksPage.list = res.data.list
        this.painterWorksPage.total = res.data.total
        this.painterWorksPage.wordCountTotal = res.data.wordCountTotal
      })
    },
    initHeader() {
      window.addEventListener('mousewheel', this.handleScroll, true) || window.addEventListener('DOMMouseScroll', this.handleScroll, false)
    },
    handleScroll(e) {
      let direction = e.deltaY > 0 ? 'down' : 'up'
      if (direction === 'down') {
        setTimeout(() => {
          this.$set(this, 'header2Lit', false)
        }, 0)
      } else {
        setTimeout(() => {
          this.$set(this, 'header2Lit', true)
        }, 0)
      }
    },
  }
}
</script>

<style scoped lang="scss">
.works-list{
  width: 100%;
  overflow: hidden;

}

$width1440: 1440px;
.title-wrap {
  width: $width1440;
  margin: 30px auto;
  height: 85px;
  line-height: 75px;
  left: 70px;
  font-size: 30px;
  color: #fff;
  background-color: #9a7a50;
  text-align: center;


  span {
    vertical-align: middle;
  }

  img {
    vertical-align: middle;
   width: 80px;

    &:nth-child(1) {
      margin-right: 0px;
    }

    &:nth-child(3) {
      margin-left: 20px;
      transform: scaleX(-1);
    }
  }
}
* img,span,a,div{
  user-select: none;
  -webkit-user-drag:none;
}
</style>
